export const CollateralFormLinesMock = [
    {
        horse: 'ROY\'S MAGIC',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'E S Ngwane',
        weight: '52',
        drawRunners: '6-15',
        finishPosition: '3',
        lengthBehind: '2.25',
        winnerOrSecond: 'ARCHILLES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '62',
        weightForAgeNow: '0'
    },
    {
        horse: 'PUTCHINI',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'W Kennedy',
        weight: '59',
        drawRunners: '13-15',
        finishPosition: '13',
        lengthBehind: '9.15',
        winnerOrSecond: 'ARCHILLIES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '50.5',
        weightForAgeNow: '2'
    },
    {
        horse: 'ROY\'S MAGIC',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'E S Ngwane',
        weight: '52',
        drawRunners: '6-15',
        finishPosition: '3',
        lengthBehind: '2.25',
        winnerOrSecond: 'ARCHILLES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '62',
        weightForAgeNow: '0'
    },
    {
        horse: 'PUTCHINI',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'W Kennedy',
        weight: '59',
        drawRunners: '13-15',
        finishPosition: '13',
        lengthBehind: '9.15',
        winnerOrSecond: 'ARCHILLIES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '50.5',
        weightForAgeNow: '2'
    },
    {
        horse: 'ROY\'S MAGIC',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'E S Ngwane',
        weight: '52',
        drawRunners: '6-15',
        finishPosition: '3',
        lengthBehind: '2.25',
        winnerOrSecond: 'ARCHILLES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '62',
        weightForAgeNow: '0'
    },
    {
        horse: 'PUTCHINI',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'W Kennedy',
        weight: '59',
        drawRunners: '13-15',
        finishPosition: '13',
        lengthBehind: '9.15',
        winnerOrSecond: 'ARCHILLIES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '50.5',
        weightForAgeNow: '2'
    },
    {
        horse: 'ROY\'S MAGIC',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'E S Ngwane',
        weight: '52',
        drawRunners: '6-15',
        finishPosition: '3',
        lengthBehind: '2.25',
        winnerOrSecond: 'ARCHILLES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '62',
        weightForAgeNow: '0'
    },
    {
        horse: 'PUTCHINI',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'W Kennedy',
        weight: '59',
        drawRunners: '13-15',
        finishPosition: '13',
        lengthBehind: '9.15',
        winnerOrSecond: 'ARCHILLIES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '50.5',
        weightForAgeNow: '2'
    },
    {
        horse: 'ROY\'S MAGIC',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'E S Ngwane',
        weight: '52',
        drawRunners: '6-15',
        finishPosition: '3',
        lengthBehind: '2.25',
        winnerOrSecond: 'ARCHILLES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '62',
        weightForAgeNow: '0'
    },
    {
        horse: 'PUTCHINI',
        date: '16 May 18',
        course: 'SCT',
        going: 'S',
        distance: '1600',
        jockey: 'W Kennedy',
        weight: '59',
        drawRunners: '13-15',
        finishPosition: '13',
        lengthBehind: '9.15',
        winnerOrSecond: 'ARCHILLIES (59)',
        weightThen: '52',
        weightForAgeThen: '0',
        weightNow: '50.5',
        weightForAgeNow: '2'
    }
];
